import {FC} from 'react';
import clsx from 'clsx';
import SectionHeader from 'components/SectionHeader';
import Stroke from 'pages/Portal/components/Stroke';
import CompanyToClientBlock from '../CompanyToClientBlock';

type CompanyHeaderProps = {
    className?: string;
    clientName: string;
    partnerName: string;
};

const CompanyHeader: FC<CompanyHeaderProps> = ({
    className,
    clientName,
    partnerName,
}) => (
    <div className={clsx('flex', className)}>
        <SectionHeader
            classNameTitle="mt-2"
            hideHR={true}
            level={1}
            title={
                <div className="mt-2 flex max-w-5xl 2xl:max-w-[94rem]">
                    <Stroke />
                    <CompanyToClientBlock
                        clientName={clientName}
                        iconSize="lg"
                        partnerName={partnerName}
                    />
                </div>
            }
        />
    </div>
);

export default CompanyHeader;
